import { RemoteQueueEntry } from '~/modules/remote-mic/network/client/subscriptions';
import { SongQueueItem } from '~/modules/song-queue/song-queue';

// What a phone needs of the queue: enough to draw a row it may not have in its own song list.
export const remoteQueueEntries = (queue: readonly SongQueueItem[]): RemoteQueueEntry[] =>
  queue.map(({ song, addedBy, addedById }) => ({
    id: song.id,
    title: song.title,
    artist: song.artist,
    video: song.video || undefined,
    duration: song.duration,
    addedBy,
    addedById,
  }));
